var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-container',{staticClass:"layout-root"},[_c('AdminSidebar'),_c('el-container',{staticClass:"layout-main-wrap",attrs:{"direction":"vertical"}},[_c('AppHeader'),_c('el-main',{staticClass:"layout-main"},[_c('router-view')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }